var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRfq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 34,
    viewBox: "0 0 6 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1086954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7517",
    x: 6,
    width: 34,
    height: 6,
    rx: 3,
    transform: "rotate(90 6 0)",
    fill: "#06CEA8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7518",
    x: 6,
    y: 28,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 6 28)",
    fill: "#05949C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRfq);
export default __webpack_public_path__ + "static/media/arrow-rfq.ac2f11069f5ebbe2e9407425c94e3bbc.svg";
export { ForwardRef as ReactComponent };